
import { defineComponent } from 'vue'

import RepoDetailMixin, { REPO_PERMS } from '~/mixins/repoDetailMixin'
import { Maybe, RepositoryPermissionChoices, TeamMember } from '~/types/types'

export default defineComponent({
  name: 'AddCollaboratorModal',
  mixins: [RepoDetailMixin],
  data() {
    return {
      memberSearchCandidate: '',
      selectedMember: null as Maybe<TeamMember>,
      fetching: false,
      repoPerms: REPO_PERMS,
      selectedRole: RepositoryPermissionChoices.Write
    }
  },
  computed: {
    hasMembers(): boolean {
      return Boolean(this.repository.addableMembers?.edges?.length)
    }
  },
  methods: {
    async fetchMembers() {
      this.fetching = true
      await this.fetchAddableMembers({
        ...this.baseRouteParams,
        q: this.memberSearchCandidate
      })
      this.fetching = false
    },
    async addMember() {
      try {
        if (this.selectedMember) {
          const response = await this.updateMemberPermission({
            input: {
              repositoryId: this.repository.id,
              userId: this.selectedMember.user.id,
              permission: this.selectedRole
            }
          })
          if (!response?.ok) {
            throw new Error()
          }

          if (this.selectedMember?.user?.fullName) {
            this.$toast.success(
              `${this.selectedMember.user.fullName} successfully added as a collaborator.`
            )
          } else {
            this.$toast.success('Collaborator added successfully')
          }

          this.$emit('refetch-collaborators')
          this.selectedMember = null
          this.close()
        }
      } catch (e) {
        const toastMsg = (e as Error).message
          ? (e as Error).message.replace('GraphQL error: ', '')
          : 'Failed to add collaborator.'
        this.$toast.danger(toastMsg)
      }
    },
    close() {
      this.selectedMember = null
      this.$emit('close-modal')
    }
  }
})
